import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_18 = {
  class: "modal fade createNewModal",
  id: "ModalDetail",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "detailModalRef"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_20 = { class: "modal-content p-15 p-md-40" }
const _hoisted_21 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_22 = { class: "modal-title fw-bold text-black" }
const _hoisted_23 = { class: "modal-body ps-0 pe-0 pb-0 pt-5" }
const _hoisted_24 = { class: "card mb-25 border-0 rounded-0 bg-white to-do-list-box" }
const _hoisted_25 = { class: "card-body p-5 letter-spacing" }
const _hoisted_26 = { class: "to-do-list ps-0 list-unstyled mb-0" }
const _hoisted_27 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_37 = { class: "col-md-9" }
const _hoisted_38 = { class: "to-do-list-item ps-8 pe-5 d-flex align-items-center justify-content-between" }
const _hoisted_39 = { class: "col-md-9" }
const _hoisted_40 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "search-box position-relative me-15",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Rechercher un bureau"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ID "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " UTILISATEUR ID "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " NOM D'UTILISATEUR "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " TABLE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " OPERATION "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " DATE "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ADRESSE MAC "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " ADRESSE IP "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                })
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journals, (jou, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(jou.id), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(jou.userId), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(jou.userName), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(jou.entityName), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(jou.action), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.format_date(jou.createdAt)), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(jou.addressMac), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(jou.addressIP), 1),
                  _createElementVNode("td", _hoisted_15, [
                    (_ctx.checkPermission('AddBureau'))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "default-btn position-relative transition border-0 fw-medium text-white pt-5 pb-5 ps-15 pe-15 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                          href: "#",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#ModalDetail",
                          onClick: ($event: any) => (_ctx.getJournalOperation( jou.id ))
                        }, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Détails ", -1)
                        ]))], 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("h5", _hoisted_22, "Détail de l'opération " + _toDisplayString((_ctx.journal) ? _ctx.journal.id : '') + " du " + _toDisplayString((_ctx.journal) ? _ctx.format_date(_ctx.journal.createdAt) : ''), 1)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("ul", _hoisted_26, [
                  _createElementVNode("li", _hoisted_27, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "ID UTILISATEUR")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_28, _toDisplayString((_ctx.journal) ? _ctx.journal.userId : ''), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "NOM UTILISATEUR")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_29, _toDisplayString((_ctx.journal) ? _ctx.journal.userName : ''), 1)
                  ]),
                  _createElementVNode("li", _hoisted_30, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "ID TABLE")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_31, _toDisplayString((_ctx.journal) ? _ctx.journal.entityId : ''), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "NOM TABLE")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_32, _toDisplayString((_ctx.journal) ? _ctx.journal.entityName : ''), 1)
                  ]),
                  _createElementVNode("li", _hoisted_33, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "ADRESSE IP")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_34, _toDisplayString((_ctx.journal) ? _ctx.journal.addressIP : ''), 1),
                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "ADRESSE MAC")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_35, _toDisplayString((_ctx.journal) ? _ctx.journal.addressMac : ''), 1)
                  ]),
                  _createElementVNode("li", _hoisted_36, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "OPERATION EFFECTUÉE")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_37, _toDisplayString((_ctx.journal) ? _ctx.journal.action : ''), 1)
                  ]),
                  _createElementVNode("li", _hoisted_38, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("span", { class: "fw-medium text-black-emphasis" }, [
                        _createElementVNode("b", null, "CONTENU DE L'OPERATION")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_39, [
                      (_ctx.journal && _ctx.journal.contenu && _ctx.journal.contenu.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.journal.contenu), (value, key) => {
                              return (_openBlock(), _createElementBlock("div", { key: key }, [
                                (!['createdAt', 'updatedAt', 'deletedAt', 'userCreation'].includes(key))
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(key) + ": " + _toDisplayString(value), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ])
      ])
    ], 512)
  ], 64))
}